/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InventoryStockTakesDto as DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto } from '../../models/Digiwork/MaitreD/Pos/DTO/InventoryStockTake/inventory-stock-takes-dto';

export interface GetInventoryStockTakes$Params {
  inventoryId: string;
  searchTerm?: string;
}

export function getInventoryStockTakes(http: HttpClient, rootUrl: string, params: GetInventoryStockTakes$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto>> {
  const rb = new RequestBuilder(rootUrl, getInventoryStockTakes.PATH, 'get');
  if (params) {
    rb.path('inventoryId', params.inventoryId, {});
    rb.query('searchTerm', params.searchTerm, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoInventoryStockTakeInventoryStockTakesDto>;
    })
  );
}

getInventoryStockTakes.PATH = '/api/inventories/{inventoryId}/stock-takes';
